import { Component } from 'react';
import { validator } from 'Helpers/validator';
import { ReactComponent as ArrowDown } from 'assets/images/svg/arrow-icon.svg';

export default class DropDown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: this.props.selectedOption
        }
        this.validator = validator.getInstance();
    }

    optionRender = () => {
        if (!this.props.optionRender) return null;
        return this.props.optionRender();
    }

    handleInputChange = (event) => {
        this.setState({
            selectedOption: event.target.value
        })
        this.props.dispatchFunction(event);
    }

    componentDidUpdate(prevProps){
        if(prevProps.refreshGridTime !== this.props.refreshGridTime && this.state.selectedOption){
            this.setState({ selectedOption: undefined });
        }
    }

    render() {
        const { requiredfield } = this.props;
        const { selectedOption } = this.state;
        return (
            <>
                <div className='select_dwn_box'>
                    <select
                        value={ selectedOption || '' }
                        onChange={ this.handleInputChange }
                        data-validation={ (requiredfield) ? [ 'requiredfield' ] : undefined }
                        name={ this.props.name }
                    >
                        <option value="">{ this.props.DropdownText }</option>
                        {this.optionRender()}
                    </select>
                    {/* <svg width="14" height="14" viewBox="0 0 14 14"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
                    {/* <svg  width="20" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
                    <ArrowDown/>

                </div>
            </>
        )
    }
}